import { ToolbarVolumeIconPolygon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, ProductTypes } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { UserInfo } from '@editor/interfaces/user'

import VolumeSetupPanel from './Polygon/components/VolumeSetupPanel'
import useEditor from './Polygon/hooks/useEditor'
import useElementsPanel from './Polygon/hooks/useElementsPanel'
import useMainCanvas from './Polygon/hooks/useMainCanvas'

const VolumeEstimation: EditorTool = {
  key: EDITOR_TOOLS.VOLUME_POLYGON,
  cursor: CursorState.CROSSHAIR,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Hatsuly) && isAllowedToModify) || false,
  toolbar: {
    icon: <ToolbarVolumeIconPolygon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.VOLUME,
    category: ToolbarCategory.Generate,
  },
  hooks: {
    useMainCanvas,
    useEditor,
    useElementsPanel,
  },
  components: {
    panel: VolumeSetupPanel,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
    dependencies: [EDITOR_TOOLS.CYLINDER, EDITOR_TOOLS.DEPTH, EDITOR_TOOLS.GRID],
  },
}

export default VolumeEstimation
